module.exports = __webpack_public_path__ + "img/about.311d6c32.svg";